import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import SelectedCEBlock from "./SelectedCEBlock";

interface Props {
  aeId: string;
  aeTexto: string;
  criterios: Record<
    string,
    {
      id: string;
      texto: string;
      objetivos: Record<string, { id: string; texto: string }>;
    }
  >;
  onRemoveOG: (ceId: string, ogId: string) => void;
}

const SelectedAECard: React.FC<Props> = ({ aeTexto, criterios, onRemoveOG }) => {
const ceEntries = Object.entries(criterios ?? {});

  return (
    <Box
      sx={{
        border: "1px solid rgba(0,0,0,0.10)",
        borderRadius: "10px",
        overflow: "hidden",
        backgroundColor: "#FFFFFF",
      }}
    >
      <Typography
        sx={{
          fontFamily: "Montserrat",
          fontSize: "0.7rem",
          fontWeight: 700,
          color: "rgba(0,0,0,0.60)",
          mb: 0.8,
          ml: 1,
        }}
      >
        APRENDIZAJE ESPERADO
      </Typography>

      <Box sx={{ p: 1.2, backgroundColor: "rgba(0,0,0,0.03)" }}>
        <Typography
          sx={{
            fontFamily: "Montserrat",
            fontSize: "0.7rem",
            fontWeight: 400,
            color: "rgba(0,0,0,0.60)",
            lineHeight: 1.25,
          }}
        >
          {aeTexto}
        </Typography>
      </Box>

      <Box sx={{ p: 1.2 }}>
        <Stack spacing={0}>
          {ceEntries.map(([ceId, ce]) => (
            <SelectedCEBlock
              key={ceId}
              ceId={ceId}
              ceTexto={ce.texto}
              objetivos={ce.objetivos}
              onRemoveOG={(ogId) => onRemoveOG(ceId, ogId)}
            />
          ))}
        </Stack>
      </Box>
    </Box>
  );
};

export default SelectedAECard;
